import React, {useMemo} from 'react';
import "../style/header-custom.scss";
import {Menu, Layout, Alert, Icon} from '@core/idtek-component';
import {useLocation, useNavigate} from "react-router-dom";
import {useBookingInfoContext} from "../hook/useBookingInfoContext";
import _ from "lodash";
import {useAppContext} from "../hook/useAppContext";
import AppUtil from "../util/AppUtil";

const HeaderMobile = () => {
    const {appState, setAppState} = useAppContext()!;
    const {location, user} = appState;
    const {
        setBookingInfoState,
    } = useBookingInfoContext()!;
    const navigate = useNavigate();

    const locationPath = useLocation();

    const onClick = (param: any) => {
        switch (_.get(param, "key")) {
            case '1':
                navigate && navigate({
                    pathname: `/booking/${appState.locationCode}`,
                    search: `?action=set-booking`
                });
                break;
            case '2':
                navigate && navigate({
                    pathname: `${AppUtil.PUBLIC_URL}/history/${location?.code}`,
                    search: `?action=history`
                });
                break;

            case '3':
                const bookingUrl = `${window.location.origin}${AppUtil.PUBLIC_URL}/booking/${location?.code}?action=set-booking`
                const aboutUsUrl = `${window.location.origin}${AppUtil.PUBLIC_URL}/review/${location?.code}`
                const loginUrl = `${window.location.origin}${AppUtil.PUBLIC_URL}/bff/login`;


                navigate({
                    pathname: "/bff/login",
                    search: `?isBookingOnline=true&locationCode=${location?.code}
                    &bookingUrl=${encodeURIComponent(bookingUrl)}
                    &loginUrl=${encodeURIComponent(loginUrl)}
                    &returnUrl=${encodeURIComponent(bookingUrl)}
                    &aboutUsUrl=${encodeURIComponent(aboutUsUrl)}`
                })

                window.location.reload();
                break;

            case '4':
                onLogOut();
                break;

            case '5':
                navigate && navigate({
                    pathname: `/review/${location?.code}`,
                });
                break;
        }
    }

    const defaultSelectedFunction = (): string[] | undefined => {
        switch (locationPath.pathname) {
            case `${AppUtil.PUBLIC_URL}/location/${location?.code}`:
                return ['1'];
            case `${AppUtil.PUBLIC_URL}/history/${location?.code}`:
                return ['2'];
            case `${AppUtil.PUBLIC_URL}/login/${location?.code}`:
                return ['3'];
        }
    }

    const onLogOut = async () => {
        const confirm = await Alert.Swal_confirm(
            "Signing out",
            "Are you sure you want to sign out?",
            3
        );
        if (confirm.value === true) {

            setAppState({user: undefined})
            setBookingInfoState({phone: undefined, email: undefined, customerName: undefined})
            navigate && navigate({
                pathname: "/bff/logout",
            })

            window.location.reload();
        }
    }

    const renderMenu = () => {
        console.log(appState?.user?.userName === '')
        return <>
            {!AppUtil.isNullOrUndefined(appState?.user?.userName) &&
                <Menu className="menu-bar-custom menu-bar-custom-mobile" mode="horizontal"
                      selectedKeys={defaultSelectedKey}
                      onClick={onClick}>
                    <Menu.SubMenu key={"MENU"} title={"MENU"} icon={<Icon type={'unordered-list'}/>}
                                  style={{display: "flex", alignItems: "center"}}>
                        <Menu.Item key="1">BOOK</Menu.Item>
                        <Menu.Item key="2">HISTORY</Menu.Item>
                        <Menu.Item key="5">ABOUT US</Menu.Item>
                        <Menu.SubMenu title={appState?.user?.firstName?.toUpperCase()}>
                            <Menu.Item key="4">LOG OUT</Menu.Item>
                        </Menu.SubMenu>
                    </Menu.SubMenu>
                </Menu>}

            {AppUtil.isNullOrUndefined(appState?.user?.userName) &&
                <Menu className="menu-bar-custom menu-bar-custom-mobile" mode="horizontal"
                      selectedKeys={defaultSelectedKey}
                      onClick={onClick}>
                    <Menu.SubMenu key={"MENU"} title={"MENU"} icon={<Icon type={'unordered-list'}/>}
                                  style={{display: "flex", alignItems: "center"}}
                    >
                        <Menu.Item key="1">BOOK</Menu.Item>
                        <Menu.Item key="5">ABOUT US</Menu.Item>
                        <Menu.Item key="3">LOG IN</Menu.Item>
                    </Menu.SubMenu>
                </Menu>}
        </>

    }

    const defaultSelectedKey = defaultSelectedFunction();

    return useMemo(() => {
            const logoImage = AppUtil.GLOBAL_TENANT_API_PATH + "/download/" + _.get(location, "logoFileId")
            return (
                <Layout.Header className="location-header">
                    <nav className="header-custom navbar navbar-fixed-top navbar-default ember-view" style={{
                        display: 'flex'
                    }}>
                        <div className="logo">
                            <img alt="" src={logoImage}/>
                        </div>
                        <div className="header-right">
                            {renderMenu()}
                        </div>

                    </nav>
                </Layout.Header>
            )
        }
        , [location, defaultSelectedKey, user]);
};


export default HeaderMobile;